import * as Yup from 'yup';

import { validateBrPhone } from '../../utils';

const requiredMessage = 'Campo obrigatório';

export const addressValidationSchema = Yup.object().shape({
  phone_number: Yup.string()
    .required(requiredMessage)
    .test({
      name: 'phone_number',
      message: 'Telefone inválido',
      test(value) {
        return validateBrPhone(value ?? '');
      },
    }),
  zip_code: Yup.string().required(requiredMessage),
  address: Yup.string().required(requiredMessage),
  number: Yup.string()
    .transform((value, originalValue) => {
      if (
        originalValue === '' ||
        originalValue === 'null' ||
        originalValue === null
      ) {
        return undefined;
      }
      return value;
    })
    .required(requiredMessage),
  complement: Yup.string(),
  neighborhood: Yup.string().required(requiredMessage),
  city: Yup.string().required(requiredMessage),
  state: Yup.string().required(requiredMessage),
  is_clinic_address: Yup.boolean()
    .required(requiredMessage)
    .oneOf([true], 'Confirmo que os dados fornecidos são da minha clínica.'),
});
